import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { CarNorskElbilforeningProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/CarNorskElbilforeningProduct";
import React from "react";

export const carNorskElbilforeningDetailsList = (
  product: CarNorskElbilforeningProduct,
  types: any,
  lang: string,
): ProductDetail[] => [
  {
    name: "deductible",
    value: (
      <DeductibleValue
        value={product.priceSpecifications.deductible.code ?? "??"}
      />
    ),
  },
  {
    name: "insurance",
    value: types.coverageGroup[product.coverageGroup][lang],
  },
  {
    name: "yearlyKmNeed",
    value: product.yearlyKmNeed && types.yearlyKmNeed[product.yearlyKmNeed],
  },
  { name: "damageRecentYears", value: product.damageCountRecentYears ?? 0 },
  {
    name: "yearOfLastDamage",
    value: product.yearOfLastDamage,
    hidden: product.damageCountRecentYears === 0,
  },
  {
    name: "usedByYoungDriver",
    value: <YesOrNo value={product.usedByYoungerDriver} />,
  },
  {
    name: "mortgagee",
    value: <YesOrNo value={product.mortgagee} />,
  },
  {
    name: "insuranceHolderIsCarOwner",
    value: <YesOrNo value={!product.insuranceHolderIsOwner} />,
  },
  {
    name: "bonus",
    value: types.bonusLevelCode[product.bonusLevelCode],
  },
  {
    name: "elCarUnionMembershipMail",
    value: product.elCarUnionMembershipMail ?? "",
  },
];
